(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.product_gallery = {
    attach: function (context, settings) {

      $(once('slick', '.node__header-product-images .field--name-field-gallery')).each(function(_, $el) {
        $($el).slick({
          dots: true,
          autoplay: true,
          autplaySpeed: 5000,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          lazyLoad: 'progressive'
        });
      });
    }
  }

})(jQuery, Drupal, this, this.document);
